import React, { useEffect }  from "react";
import ProviderNavbar from "../../provider-navbar/components";
// import "../style/header-style.css";
import IC_logo from "../../../../assets/images/ic_logo_1.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { logout as clientLogout, selectClientAuth } from "../../../../Clients/components/auth-client/slice/clientAuth";
import { logout , selectProviderAuth } from "../../auth-provider/slice/providerAuth";
// import { providerIncrementNotification, providerResetNotifications } from "../slice/providerChatNotificationSlice";
// import Pusher from "pusher-js";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProviderHeader = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const unreadCount = useSelector((state) => state.providerChatNotifications.providerUnreadCount);

    //  console.log("unreadCount", unreadCount);

    const isProviderLoggedIn = useSelector(selectProviderAuth);

      //     useEffect(() => {
      //   const providerToken = localStorage.getItem("provider_access_token");
      //   if (!providerToken) return;
    
      //   const pusher = new Pusher("71055cc21a087085dc31", {
      //     cluster: "ap2",
      //     forceTLS: true,
      //     authEndpoint: `${BACKEND_URL}/pusher/auth`,
      //   });
    
      //   // Subscribe to a "global" channel for this client
      //   const channel = pusher.subscribe("private-chat_room");
    
      //   channel.bind("App\\Events\\ChatRoomCreated", (data) => {
      //     dispatch(providerIncrementNotification());
      //   });
    
      //   return () => {
      //     channel.unbind_all();
      //     channel.unsubscribe();
      //     pusher.disconnect();
      //   };
      // }, [dispatch]);

  const handleProviderLogout = () => {
    dispatch(logout());
    navigate("/provider");
  };
  return (
    <>
        {/* <div className="header-main"> */}
            {/* <div className="header">
                <div className="header-left">
                    <img src={IC_logo} alt="IC Logo" className="logo-img" />
                </div>
                <div className="header-right">
        {isProviderLoggedIn ? (
          <button className="header-btn" onClick={handleProviderLogout}>
            Provider Logout
          </button>
        ) : (
          <>
            <Link to="/provider/signin">
              <button className="header-btn">Provider Login</button>
            </Link>
            <Link to="/provider/signup">
              <button className="header-btn">Provider Register</button>
            </Link>
          </>
        )}
      </div>
            </div> */}

            <header className="header-top">
         <div className="tophad bg-primary pt-2 pt-lg-3 d-none d-lg-block">
            <div className="container">
               <div className="row justify-content-end align-items-center">
                  <div className="col-auto">
                     <div className="d-flex">
                        <div className="align-items-center d-flex">
                           <div className="d-flex align-items-center">
                              {/* <div className="position-relative me-4">
                                <i className="fa fa-bell fa-lg text-white"></i>
                                
                                {unreadCount > 0 && (
                                  <span 
                                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                    style={{ fontSize: "0.7rem", minWidth: "18px" }}
                                  >
                                    {unreadCount}
                                  </span>
                                )}
                              </div> */}
                              <div className="me-0 me-lg-2"><a href="#" className="text-decoration-none"><img src="/assets/images/header-gmail.svg" alt="..." className="" /></a></div>
                              <div className=""><a href="#" className="font-size-18 font-weight-semibold line-hight-3 text-white text-decoration-none">Info@justgen.org</a>
                              </div>
                           </div>
                           <div className="d-flex align-items-center ms-3 me-2  ms-md-4 me-md-3">
                              <div className="me-0 me-lg-2"><a href="#" className="text-decoration-none"><img src="/assets/images/header-call.svg" alt="..." className="" /></a></div>
                              <div className=""><a href="#" className="font-size-18 font-weight-semibold line-hight-3 text-white text-decoration-none">+757-937-1738</a>
                              </div>
                           </div>
                        </div>
                        <div className="mt-1">
                           {/* <a href="https://www.facebook.com/profile.php?id=61575600418282" target="_blank"  rel="noopener noreferrer" className="fb"></a> */}
                           <a href="https://www.facebook.com/profile.php?id=61575600418282" target="_blank" className="text-white"
  rel="noopener noreferrer"><i className="fa fa-facebook me-2"></i></a>
                           <a href="https://www.linkedin.com/company/107183458/admin/dashboard/" target="_blank" className="text-white"  rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                           {/* <a href="#" className="tw ms-1 ms-sm-2"></a>
                           <a href="#" className="pin ms-1 ms-sm-2"></a>
                           <a href="#" className="ista ms-1 ms-sm-2"></a> */}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>


            <ProviderNavbar />
            </header>
        {/* </div> */}
    </>
  );
};

export default ProviderHeader;
